import { render, staticRenderFns } from "./copyTextDialog.vue?vue&type=template&id=f8879a20&scoped=true&"
import script from "./copyTextDialog.vue?vue&type=script&lang=js&"
export * from "./copyTextDialog.vue?vue&type=script&lang=js&"
import style0 from "./copyTextDialog.vue?vue&type=style&index=0&id=f8879a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8879a20",
  null
  
)

export default component.exports